import axios from "axios";
import { useEffect, useState } from "react"
import { Link, NavLink, useParams } from "react-router-dom"
import Loading from './../../Loading';
import { userTrafficEdit, userTrafficEdit_put } from './../../../api/api';
import { toast } from 'react-toastify';



const UserTrafficEdit = () => {

     const params = useParams()
     const [opTypeSelect, setOpTypeSelect] = useState(0)
     const [isLoading, setIsLoading] = useState(false)
     const [isLoadingForm, setIsLoadingForm] = useState(false)
     const [operatorsType, setOperatorsType] = useState([])
     const [refreshData, setRefreshData] = useState(false)

     const [trafficKBToGB, setTrafficKBToGB] = useState('')


     function formatBytes(bytes, decimals = 2) {
          if (!+bytes) return '0 Bytes'

          const k = 1000
          const dm = decimals < 0 ? 0 : decimals
          const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

          const i = Math.floor(Math.log(bytes) / Math.log(k))

          setTrafficKBToGB(`${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`)
     }

     useEffect(() => {

          const GET_userTrafficEdit = async () => {
               try {
                    setIsLoading(true)
                    const res = await axios.get(userTrafficEdit(params.userId))
                    setOperatorsType(res.data)
                    const filterOp = res.data.filter(op => op.operatorType.id == res.data[0].operatorType.id)
                    setOpTypeSelect(filterOp[0].trafficKB)
                    formatBytes(filterOp[0].trafficKB * 1000)
               } finally { setIsLoading(false) }
          }
          GET_userTrafficEdit()

     }, [refreshData])


     useEffect(() => {
          formatBytes(opTypeSelect * 1000)
     }, [opTypeSelect])


     const handleSubmitForm = async (e) => {
          e.preventDefault()

          let traffic = e.target.traffic.value !== '' ? parseInt(e.target.traffic.value) : 0
          let operatorTypes = parseInt(e.target.operatorTypes.value)

          try {
               setIsLoadingForm(true)
               await axios.put(userTrafficEdit_put(params.userId), {
                    operatorType: operatorTypes,
                    traffic: traffic
               })
               toast.success('ترافیک بروز شد.')
               setRefreshData(!refreshData)
          } finally { setIsLoadingForm(false) }
     }




     const handleSelectTypeChange = e => {
          const filterOp = operatorsType.filter(op => op.operatorType.id == e.target.value)
          setOpTypeSelect(filterOp[0].trafficKB)
     }
     const handleChangeInput = e => {
          setOpTypeSelect(e.target.value)
     }



     return (
          <>
               <div className='row' style={{ margin: '0' }}>
                    <div className='col-12 searchTypeRow'>
                         <div className='topnav'>
                              <Link to={`/users/${params.userId}`}>ویرایش کاربر</Link>
                              <NavLink to={`/users/${params.userId}/traffic`}>مدیریت ترافیک</NavLink>
                         </div>
                    </div>
               </div>


               <div className="contentHolder pb-0">
                    <div className="row">
                         <div className="col-12">
                              <div className="box_radios">


                                   <div className="requestSettingForm" style={{ padding: '20px' }}>
                                        {isLoading ? <Loading styles={'mini'} /> : (

                                             <form onSubmit={handleSubmitForm}>

                                                  <p>
                                                       <span style={{ fontWeight: 300, display: 'block', marginBottom: '1rem' }}>اپراتور :</span>
                                                       <select name="operatorTypes" id="operatorTypes" defaultValue={opTypeSelect} onChange={handleSelectTypeChange}>
                                                            {operatorsType && operatorsType.map(op => (
                                                                 <option key={op.operatorType.id} value={op.operatorType.id}>{op.operatorType.title}</option>

                                                            ))}
                                                       </select>
                                                  </p>


                                                  <p>
                                                       <span style={{ fontWeight: 300 }}>ترافیک (به کیلوبایت) :</span>
                                                       <input type="number" value={opTypeSelect} name='traffic' onChange={handleChangeInput} />
                                                       <small style={{ direction: 'ltr', textAlign: 'right', fontFamily: 'sans-serif', display: 'block', }}>{trafficKBToGB}</small>
                                                  </p>

                                                  <br />
                                                  {isLoadingForm
                                                       ?
                                                       <p><button type="button" className='disabled' style={{ padding: '1rem 2rem' }}> لطفا صبر کنید...</button></p>
                                                       :
                                                       <p><input type="submit" value="ذخیره" /></p>
                                                  }
                                             </form>
                                        )}

                                   </div>

                              </div>
                         </div>
                    </div>
               </div>
          </>
     )
}

export default UserTrafficEdit